import { Toast } from 'bootstrap';

const successAlert = document.getElementById('success-alert');

if (successAlert !== null) {
    const successToast = new Toast(successAlert);

    successToast.show();
}

const errorAlert = document.getElementById('error-alert');

if (errorAlert !== null) {
    const errorToast = new Toast(errorAlert);

    errorToast.show();

}
